// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"50c19f94","895":"4c3f821a"}[chunkId] + ".chunk.js";
};